import { KeepAlive } from 'react-activation'

import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import FilterSearch from './components/FilterSearch'
import { useEffect, useMemo, useRef, useState } from 'react'
import SelectPopover from '@/pages/MaterialSelectionLibrary/components/SelectPopover'
import { Checkbox, Col, Empty, Input, message, Pagination, Row, Select, Spin, Tooltip } from 'antd'
import starFollowed from '@/assets/star-followed.png'
import starNoFollow from '@/assets/star-nofollow.png'
import Emptymaterial from '@/assets/empty-material.png'
import FollowModal from './components/FollowModal'
import categoryDefault from '@/assets/category-default.png'
import {
  favoritesAdd,
  favoritesDelete,
  getBrandList,
  getOriginList,
  getSpecsList,
  getStyleList,
  goodsStoreCategoryTree,
  goodsStorePage,
  queryApplyPackage,
} from '@/services/goodsFrontendTenant'
import HorizontalScrollGallery from './components/HorizontalScrollGallery'
import TagCheckBox from '@/components/TagCheckBox'
import { useDebounceEffect, useUpdateEffect } from 'ahooks'
import { debounce, isArray } from 'lodash-es'
import DebounceSelect from './components/DebounceSearchSelect'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import _, { isBoolean, isEqual } from 'lodash'
import { searchParamsAtom } from './store'
import { queryAllDecoCompany } from '@/services/getUsers'
const { Search } = Input
export default function MaterialSelectionLibrary() {
  const navigate = useNavigate()
  const [followOpen, setFollowOpen] = useState(false)
  const [data, setData] = useState<any>([])
  const [pagination, setPagination] = useState({
    pageId: 1,
    pageSize: 30,
    total: 0,
    pageSizeOptions: ['30', '60', '90', '100', '200'],
  })
  const [state, setState] = useState<any>({
    applyPackageList: [], //标配值列表
    categoryIdList: [], //分类列表
    brandList: [], //品牌列表
    styleList: [], //品牌列表
    companyList: [], // 能查看的公司数据
  })
  const [loading, setLoading] = useState(true)
  const [brandId, setBrandId] = useState(undefined)
  const [categoryValue, setCategoryValue] = useState<any>({})
  const [secondCategoryValue, setSecondCategoryValue] = useState<any>(null)
  const [filterGoodsId, setFilterGoodsId] = useState<any>('')
  const [style, setStyle] = useState(undefined)
  const [origin, setOrigin] = useState(undefined)
  const [specs, setSpecs] = useState(undefined)
  const [filterOrgId, setFilterOrgId] = useState(undefined)

  const [queryFavorite, setQueryFavorite] = useState(undefined)
  const [productInfo, setProductInfo] = useState<any>({})
  const [queryParams, setQueryParams] = useState<any>({ pageId: 1, pageSize: 30 })
  const [fetchParams, setFetchParams] = useState<any>({ pageId: 1, pageSize: 30 })
  const queryRef = useRef<any>()

  const debounceSelectOriginRef = useRef<any>(null)
  const debounceSelectSpecsRef = useRef<any>(null)
  const [fetchOptionParams, setFetchOptionParams] = useState<any>({})
  const [optionsLoading, setOptionsLoading] = useState(false)

  useEffect(() => {
    queryRef.current = queryParams // 同步更新
  }, [queryParams])

  // 更新参数
  useUpdateEffect(() => {
    const params: any = { ...fetchParams }

    params.brandIdList = brandId ? [brandId] : null
    params.onlyQueryFavorite = queryFavorite
    params.categoryValue = categoryValue
    params.secondCategoryValue = secondCategoryValue
    let idObj: any = {
      firstValue: params?.categoryValue?.category?.id ? params?.categoryValue?.category?.id : null,
      secondValue: params?.secondCategoryValue ? params?.secondCategoryValue : null,
    }
    params.categoryIdList = getCategoryIds(idObj) ? getCategoryIds(idObj) : null
    console.log(params, 'params')
    params.pageId = 1
    setQueryParams({
      ...params,
      filterGoodsId,
      style,
      origin,
      specs,
      categoryValue,
      secondCategoryValue,
      filterOrgId,
    })
  }, [
    filterGoodsId,
    brandId,
    queryFavorite,
    style,
    origin,
    specs,
    categoryValue,
    secondCategoryValue,
    filterOrgId,
  ])
  useUpdateEffect(() => {
    // 影响产地 规格下拉选项值
    const params = { ...fetchOptionParams }
    params.brandIdList = brandId ? [brandId] : null
    params.filterGoodsId = filterGoodsId
    params.categoryValue = categoryValue
    params.secondCategoryValue = secondCategoryValue
    let idObj: any = {
      firstValue: params?.categoryValue?.category?.id ? params?.categoryValue?.category?.id : null,
      secondValue: params?.secondCategoryValue ? params?.secondCategoryValue : null,
    }
    params.categoryIdList = getCategoryIds(idObj) ? getCategoryIds(idObj) : null
    params.searchKeyWord = fetchParams.searchKeyWord
    params.filterOrgId = fetchParams.filterOrgId
    setFetchOptionParams({
      ...params,
    })
    debounceSelectOriginRef?.current?.reload(params)
    debounceSelectSpecsRef?.current?.reload(params)
  }, [filterGoodsId, brandId, categoryValue, secondCategoryValue, filterOrgId])

  useUpdateEffect(() => {
    // 重新请求品牌
    const params = { ...fetchOptionParams }
    params.categoryValue = categoryValue
    params.secondCategoryValue = secondCategoryValue
    let idObj: any = {
      firstValue: params?.categoryValue?.category?.id ? params?.categoryValue?.category?.id : null,
      secondValue: params?.secondCategoryValue ? params?.secondCategoryValue : null,
    }
    params.categoryIdList = getCategoryIds(idObj) ? getCategoryIds(idObj) : null
    params.filterGoodsId = filterGoodsId
    params.filterOrgId = filterOrgId
    getBrandList({
      filterGoodsId: params.filterGoodsId || null,
      categoryIdList: params.categoryIdList || null,
      filterOrgId: params.filterOrgId || null,
    }).then(res => {
      if (isArray(res)) {
        res = [
          {
            name: '不限',
            id: '',
          },
          ...res,
        ]
      }
      setState({
        ...state,
        brandList: res,
      })
    })
  }, [filterGoodsId, categoryValue, secondCategoryValue, filterOrgId])
  const getCategoryIds = categoryIds => {
    if (!categoryIds) return null
    if (categoryIds.secondValue && categoryIds.firstValue) {
      return [categoryIds.secondValue]
    } else {
      return categoryIds.firstValue ? [categoryIds.firstValue] : null
    }
  }
  useUpdateEffect(() => {
    setSecondCategoryValue(null)
    setSpecs(undefined)
  }, [categoryValue])
  // 触发数据更新
  useDebounceEffect(
    () => {
      setLoading(true)
      if (optionsLoading) return
      fetchList(queryParams)
    },
    [queryParams],
    { wait: 500 }
  )

  const clickToDetail = (item: any) => {
    window.open(
      `/order/materialSelectionLibrary/materialDetail/${item?.productSpuId}${queryParams.filterOrgId ? `/${queryParams.filterOrgId}` : ''}${queryParams.filterGoodsId ? `/${queryParams.filterGoodsId}` : ''}`,
      '_blank'
    )
  }
  const clickToFollow = (item, index) => {
    setProductInfo(item)
    setFollowOpen(true)
  }
  const handleToFollow = (item, index) => {
    const newData: any = [...data]
    let targetId: any = item?.productSku?.id
    let type: any = 'SKU'
    favoritesAdd({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        newData[index].favorite = {
          targetId: item?.productSku?.id,
        }
        setData([...newData])
        message.success('收藏成功')
      })
      .catch(err => {
        console.log(err)
        // message.error('收藏失败')
      })
      .finally(() => {})
  }
  const handleToCancelFollow = (item, index) => {
    const newData = [...data]
    let targetId: any = item?.productSku?.id
    let type: any = 'SKU'
    favoritesDelete({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        newData[index].favorite = null
        setData([...newData])
        message.success('取消成功')
      })
      .catch(err => {
        console.log(err)
        // message.error('取消失败')
      })
      .finally(() => {})
  }
  const onPressEnter = (e: any) => {
    const params = { ...fetchParams }
    params.searchKeyWord = e.target.value
    params.pageId = 1
    fetchList(params)
    debounceSelectOriginRef?.current?.reload(params)
    debounceSelectSpecsRef?.current?.reload(params)
  }
  const onSearch = (value: string) => {
    const params = { ...fetchParams }
    params.searchKeyWord = value
    params.pageId = 1
    fetchList(params)
    debounceSelectOriginRef?.current?.reload(params)
    debounceSelectSpecsRef?.current?.reload(params)
  }
  // 分页
  const onChangePage = (page, pageSize) => {
    let params = { ...fetchParams }
    params.pageId = page
    params.pageSize = pageSize
    fetchList(params)
    setPagination({
      ...pagination,
      pageId: page,
      pageSize: pageSize,
    })
  }
  useEffect(() => {
    getBaseOptions()
  }, [])

  const getBaseOptions = async () => {
    setOptionsLoading(true)
    const applyPackageList = await queryApplyPackage({})
    let categoryIdList: any = await goodsStoreCategoryTree({})
    const styleList: any = await getStyleList({
      parentKey: 'stylname',
      enabled: true,
    })
    let companyList: any = await queryAllDecoCompany()
    let brandList: any = await getBrandList({
      filterOrgId: companyList[0]?.id || null,
    })
    if (isArray(companyList)) {
      companyList = companyList?.map((item: any) => {
        return {
          label: item.companyName,
          value: item.id,
        }
      })
      setFilterOrgId(companyList[0]?.value)
    }

    if (isArray(categoryIdList)) {
      categoryIdList = [
        {
          title: '全部商品',
          imgSrc: categoryDefault,
          id: '',
        },
        ...categoryIdList?.map((item: any) => {
          return {
            ...item,
            title: item?.category.cateName,
            imgSrc: item?.category?.picUrl,
          }
        }),
      ]
    }
    if (isArray(brandList)) {
      brandList = [
        {
          name: '不限',
          id: '',
        },
        ...brandList,
      ]
    }

    setState({
      ...state,
      applyPackageList,
      brandList,
      // originList,
      categoryIdList: categoryIdList || [],
      styleList: styleList?.map((item: any) => {
        return {
          label: item.name,
          value: item.key,
        }
      }),
      companyList,
    })
    setOptionsLoading(false)
  }
  const fetchList = async (params?: any) => {
    setLoading(true)
    try {
      const data: any = await goodsStorePage({
        ...params,
      })
      setPagination({
        ...pagination,
        pageSize: data.pageSize,
        pageId: data.currentPageId,
        total: data.count,
      })
      setFetchParams({ ...params })
      setData(data.list)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const handleChange = e => {
    setStyle(e)
  }
  const handleOriginChange = e => {
    if (e) {
      setOrigin(e)
    } else {
      setOrigin(undefined)
    }
  }
  const handleSpecsChange = e => {
    setSpecs(e)
    if (e) {
      setSpecs(e)
    } else {
      setSpecs(undefined)
    }
  }
  const handleFollowChange = e => {
    setQueryFavorite(e.target.checked)
  }
  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    }
  }
  const handleCompanyChange = value => {
    setFilterOrgId(value)
  }
  const changeProductInfo = (record: any) => {
    console.log(record, 'item')
    const newData = [...data]
    newData.forEach((item: any) => {
      if (item?.productSpuId === record?.productSpuId) {
        item.favorite = record.favorite
      }
    })
    setData([...newData])
  }
  const handleImg = src => {
    let zipSrc = src + '?x-oss-process=image/resize,l_800'
    return zipSrc
  }
  return (
    <div className={styles.rootBox}>
      <Spin spinning={loading}>
        <KeepAlive name={location.pathname}>
          <div className={styles.contontBox}>
            <div className={styles.searchTopBox}>
              {/* 直接搜索区 */}
              {state.companyList && state.companyList.length > 1 && (
                <Select
                  style={{ width: 220 }}
                  onChange={handleCompanyChange}
                  placeholder="公司/门店"
                  options={state.companyList}
                  value={fetchParams?.filterOrgId}
                  optionFilterProp="label"
                  showSearch
                />
              )}
              <SelectPopover
                applyPackageList={state.applyPackageList}
                setSelectValue={setFilterGoodsId}
                showValue={fetchParams?.filterGoodsId}
              ></SelectPopover>

              <Search
                placeholder="搜索商品名称/描述/SPU/SKU"
                onSearch={onSearch}
                onPressEnter={onPressEnter}
                onChange={e =>
                  setFetchParams({
                    ...fetchParams,
                    searchKeyWord: e.target.value,
                  })
                }
                value={fetchParams?.searchKeyWord}
                allowClear
                style={{ width: 280 }}
              />
            </div>
            <div className={styles.middleBox}>
              <div className={styles.searchFilterBox}>
                {/* 筛选 */}
                {/* <FilterSearch categoryIdList={state.categoryIdList} styleList={state.styleList} brandList={state.brandList} /> */}
                <div>
                  {/* 一级分类 */}
                  <HorizontalScrollGallery
                    items={state.categoryIdList}
                    getValue={setCategoryValue}
                    imgWidth={40}
                    showValue={
                      fetchParams?.categoryValue?.category?.id
                        ? fetchParams?.categoryValue?.category?.id
                        : undefined
                    }
                  ></HorizontalScrollGallery>
                  {/* 二级分类 */}
                  {categoryValue?.category?.children && (
                    <div className={styles.searchRow}>
                      <TagCheckBox
                        typeName="二级分类"
                        value={
                          fetchParams?.secondCategoryValue
                            ? fetchParams?.secondCategoryValue
                            : undefined
                        }
                        fieldNames={{ label: 'cateName', value: 'id' }}
                        dataList={[
                          { cateName: '不限', id: '' },
                          ...categoryValue?.category?.children,
                        ]}
                        setValue={value => {
                          setSecondCategoryValue(value)
                        }}
                      ></TagCheckBox>
                    </div>
                  )}

                  {/* 品牌   */}
                  <div className={styles.searchRow}>
                    <TagCheckBox
                      typeName="品牌"
                      value={fetchParams?.brandIdList ? fetchParams?.brandIdList[0] : undefined}
                      fieldNames={{ label: 'name', value: 'id' }}
                      dataList={state.brandList}
                      setValue={value => {
                        setBrandId(value)
                        // debounceSelectRef?.current?.reload()
                      }}
                    ></TagCheckBox>
                  </div>
                  {/* 筛选 */}
                  <Row className={styles.filterRow}>
                    <Col flex={'70px'} style={{ color: '#575859' }}>
                      筛选：
                    </Col>
                    <Col>
                      <Select
                        style={{ width: 200 }}
                        onChange={handleChange}
                        allowClear
                        placeholder="风格"
                        optionFilterProp="label"
                        showSearch
                        value={fetchParams?.style}
                        options={state.styleList}
                      />
                    </Col>
                    <Col>
                      <DebounceSelect
                        style={{ width: 200 }}
                        allowClear
                        label="产地"
                        resDataIsArray={true}
                        nameKey="origin"
                        onChange={handleOriginChange}
                        query={{ origin: fetchParams?.origin }}
                        value={fetchParams?.origin}
                        fixedParams={{
                          searchKeyWord: fetchParams?.searchKeyWord,
                          ...fetchOptionParams,
                        }}
                        fetchOptions={getOriginList}
                        ref={debounceSelectOriginRef}
                      />
                    </Col>
                    {categoryValue?.category?.id && (
                      <Col>
                        <DebounceSelect
                          ref={debounceSelectSpecsRef}
                          style={{ width: 200 }}
                          value={fetchParams?.specs}
                          query={{ specs: fetchParams?.specs }}
                          allowClear
                          label="规格"
                          resDataIsArray={true}
                          nameKey="specs"
                          onChange={handleSpecsChange}
                          fixedParams={{
                            searchKeyWord: fetchParams?.searchKeyWord,
                            ...fetchOptionParams,
                          }}
                          cancelInitFetch={true}
                          fetchOptions={getSpecsList}
                        />
                      </Col>
                    )}

                    <Col>
                      <Checkbox
                        checked={fetchParams?.onlyQueryFavorite}
                        onChange={handleFollowChange}
                      >
                        我的收藏
                      </Checkbox>
                    </Col>
                  </Row>
                </div>
              </div>
              {data?.length > 0 ? (
                <div className={styles.materialListBox}>
                  {data?.map((item, index) => {
                    return (
                      <div className={styles.materialCardBox} onClick={() => clickToDetail(item)}>
                        <div className={styles.cardImgBox}>
                          <img
                            className={styles.cardImg}
                            src={handleImg(item?.productSpu?.mainPicUrl)}
                          ></img>
                        </div>
                        <div className={styles.cardMiddle}>
                          <div
                            className={styles.cardTitle}
                            onClick={e => {
                              e.stopPropagation()
                            }}
                          >
                            <Tooltip title={item?.productSpuName} placement="topLeft">
                              <p> {item?.productSpuName}</p>
                            </Tooltip>
                          </div>
                        </div>
                        <div className={styles.cardFooter}>
                          <div className={styles.priceBox}>
                            <span className={styles.priceBoxSmall}>￥</span>
                            {item?.minCustomerPrice ? (
                              <>
                                {priceHandle(item?.minCustomerPrice)}
                                {item?.customerPriceList.length > 1 && (
                                  <span className={styles.priceBoxStart}>起</span>
                                )}
                              </>
                            ) : (
                              '--'
                            )}
                          </div>
                          <div
                            className={styles.followedBox}
                            onClick={e => {
                              e.stopPropagation()
                              clickToFollow(item, index)
                            }}
                          >
                            {item?.favorite?.targetId ? (
                              <img src={starFollowed} width={24} alt="" />
                            ) : (
                              // <img src={starNoFollow} width={24} alt="" />
                              <div className={styles.followedStar}></div>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : (
                !loading && (
                  <div className={styles.emptyBox}>
                    <img src={Emptymaterial} width={200} />
                  </div>
                )
              )}
            </div>
            <div className={styles.footerBox}>
              <Pagination
                total={pagination.total}
                current={pagination.pageId}
                pageSize={pagination.pageSize}
                pageSizeOptions={pagination.pageSizeOptions}
                showSizeChanger
                showQuickJumper
                showTotal={total => `共 ${total} 条`}
                onChange={onChangePage}
                // showLessItems
              />
            </div>
            {followOpen && (
              <FollowModal
                open={followOpen}
                onClose={() => {
                  // fetchList(fetchParams)
                  setFollowOpen(false)
                }}
                record={productInfo}
                fetchParams={fetchParams}
                showGoodsDetail={true}
                changeProductInfo={changeProductInfo}
              ></FollowModal>
            )}
          </div>
        </KeepAlive>
      </Spin>
    </div>
  )
}
